import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

export const checkEmpty = (value: any) => _isNil(value) || _isEmpty(value);

export const checkNotEmpty = (value: any) => !_isNil(value) && !_isEmpty(value);
